/**
 * Formats a url from table data e.g
 * @param {Object} table_data
 * @param {Object} route_template
 */
export function createUrlFromData(table_data, route_template) {
	console.log('table_data',table_data,route_template);
	let params = table_data[route_template.route_params];
	let nameTemplate = route_template.name;

	for (let i = 0; i < params.length; ++i) {
		let propertyName = params[i].name,
			propertyValue = params[i].value;

		if (route_template.is_friendly_url) {
			nameTemplate = nameTemplate.replace(`/${propertyName}`, `/${propertyValue}`);
		}
		else {
			nameTemplate = nameTemplate + ((i > 0) ? '&' : '?') + propertyName + '=' + propertyValue;
		}
	}

	return nameTemplate;
}

export function createLink(table, route_template) {
	
}



// WEBPACK FOOTER //
// ./resources/assets/js/tools/format.data_url.js